import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { InputWrapperProps } from '../input.interface';
import { styled } from '@mui/material/styles';

const Root = styled(FormControl, {
  name: 'InputWrapper',
  slot: 'Root',
})({});

const Label = styled(InputLabel, {
  name: 'InputWrapper',
  slot: 'Label',
})(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  transform: `translate(${theme.spacing(14)}, ${theme.spacing(-8)})`,
  padding: theme.spacing(0, 4),
  fontSize: '0.75rem',
  textTransform: 'capitalize',
}));

export const InputWrapper: React.FC<InputWrapperProps> = ({
  label,
  children,
  fullWidth = true,
  className,
  sx,
  htmlFor,
  labelId,
}) => (
  <Root fullWidth={fullWidth} sx={sx} className={className}>
    {label && (
      <Label shrink htmlFor={htmlFor} id={labelId}>
        {label}
      </Label>
    )}
    {children}
  </Root>
);
